module.exports = __webpack_public_path__ + "static/img/LAMB.9868d090.png";